import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Heading, CloseButton } from '@app/shared/ui/atoms/Common';
import { Page } from '@app/routes';

export function TopBar() {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between gap-2">
      <Heading level={2}>{t('edit_profile.title')}</Heading>
      <Link to={Page.PROFILE}>
        <CloseButton variant="lightgrey" />
      </Link>
    </div>
  );
}
